import { Check, Copy } from "@phosphor-icons/react";
import { useState } from "react";

export default function WebhookUrlInput({
  webhookUrl,
}: {
  webhookUrl: string;
}) {
  const [isCopied, setIsCopied] = useState(false);

  function onCopy() {
    navigator.clipboard.writeText(webhookUrl).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    });
  }

  return (
    <button
      disabled={!webhookUrl}
      className="flex min-w-0 flex-1 items-center gap-x-1 rounded-2xl bg-black-100 p-2.5 disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:ml-auto [&_svg]:shrink-0 [&_svg]:size-5"
      type="button"
      onClick={onCopy}
    >
      <span className="truncate">{webhookUrl}</span>

      {isCopied ? <Check /> : <Copy />}
    </button>
  );
}
